<div *ngIf="projectsLoaded">
  <app-search-item
    *ngFor="let project of projects"
    [project]="project"
    [loading]="!deviceDataLoaded"
  ></app-search-item>
  <ion-infinite-scroll
    [hidden]="projects?.length == totalProjects"
    (ionInfinite)="loadProjects($event)"
  >
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</div>
<app-loader [loading]="!projectsLoaded" [hidden]="projectsLoaded"></app-loader>
